import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const Row = styled.div`
  display: flex;
`;

const RowColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

const Column75 = styled.div`
  flex: 75%;
  padding: 10px;
`;

const Column25 = styled.div`
  flex: 25%;
  padding: 10px;
`;

const Column50 = styled.div`
  flex: 50%;
  padding: 10px;
`;

const Ul = styled.ul`
  padding-left: 0px;
  list-style: none;
  line-height: normal;
  margin-bottom: 2rem;
`;

const P = styled.p`
  margin-bottom: 2.5rem;
`;

const ActionNeeded = styled.span`
  margin-bottom: 2.5rem;
`;

const Hr = styled.hr`
  margin: 0;
`;

const Barcode = styled.img`
  width: 300px;
  height: 75px;
`;
const PhysicalReceipt = ({ brand, barcode }) => {
  return (
    <>
      <Row>
        <Column75>
          <h2>What happens next?</h2>
          <Ul>
            <li>
              <b>1)</b> Mail in the gift card(s) in this order to the address
              below.
            </li>
            <li>
              <b>2)</b> On receipt of the gift cards, CardCash will verify the
              balance(s).
            </li>
            <li>
              <b>3)</b> Upon successful order processing, CardCash will initiate
              your payment within one business day.
            </li>
          </Ul>
        </Column75>
        <Column25>
          <Barcode src={barcode} alt="order barcode" />
        </Column25>
      </Row>
      <RowColumn>
        <h2>Mailing Instructions</h2>
        <P>
          Please print and include a copy of this page with your package, which
          will include the cards just sold to {brand}.
        </P>
      </RowColumn>
      <Row>
        <Column50>
          <h2>USPS mail to:</h2>
          <Ul>
            <li>ABC Processing Center</li>
            <li>P.O. Box 2045</li>
            <li>Lakewood, NJ 08701</li>
          </Ul>
        </Column50>
        <Column50>
          <h2>FexEx/UPS ship to:</h2>
          <Ul>
            <li>ABC Processing Center</li>
            <li>990 Cedar Bridge Ave</li>
            <li>STE B7, RM 365</li>
            <li>Brick, NJ 08723</li>
          </Ul>
        </Column50>
      </Row>
      <RowColumn>
        <P>
          <b>
            Failure to send the cards to the proper address may result in the
            loss of your package.
          </b>
          <br />
          If you are sending more than one card, we recommend using a thick
          envelope, reinforced with taped edges, to prevent gift card from
          sliding out. For high value gift cards, we recommend adding delivery
          confirmation. Please note that most carriers do not insure cash
          equivalent items like gift cards, with the exception of USPS
          registered mail, which may offer some coverage. CardCash is not
          responsible for lost or stolen cards in transit.
        </P>
        <P>
          <b>
            Please note, if the verified balance of the sold cards is different
            than the values you reported, then the payout amount will be
            adjusted accordingly.
          </b>
        </P>
        <ActionNeeded>
          <Hr />
          Signature
        </ActionNeeded>
        <ActionNeeded>
          <Hr />
          Printed Name
        </ActionNeeded>
      </RowColumn>
    </>
  );
};

PhysicalReceipt.prototype = {
  brand: PropTypes.string.isRequired,
  barcode: PropTypes.string.isRequired,
};

export { PhysicalReceipt };
